import { rest } from 'msw';
import { makeListResults } from 'test-util/api/response';
import { getEnv } from 'util/getEnv';
import {
  appHomeConfigFixture,
  auditEntriesFixture,
  auditSnapshotsFixture,
  cleanAppHomeConfigFixture,
  previewFixture,
} from './fixtures/app-home-config.fixture';

const baseUrl = `${getEnv(
  'REACT_APP_ADMIN_API_URL',
)}/incentivio-client-domain/clients/:clientId/app-home-config`;

export const getAppHomeConfigMock = fn => rest.get(`${baseUrl}/admin`, fn);
export const saveAppHomeConfigDraftMock = fn =>
  rest.put(`${baseUrl}/draft`, fn);
export const publishAppHomeConfigDraftMock = fn =>
  rest.post(`${baseUrl}/draft/publish`, fn);
export const resetAppHomeConfigDraftMock = fn =>
  rest.post(`${baseUrl}/draft/reset`, fn);
export const setAppHomeConfigPreviewMock = fn =>
  rest.put(`${baseUrl}/preview`, fn);
export const endAppHomeConfigPreviewMock = fn =>
  rest.delete(`${baseUrl}/preview`, fn);
export const listAppHomeConfigAuditMock = fn =>
  rest.get(`${baseUrl}/audit`, fn);
export const getAppHomeConfigAuditSnapshotsMock = fn =>
  rest.get(`${baseUrl}/audit/:entryId`, fn);

export const handlers = () => [
  getAppHomeConfigMock((_req, res, ctx) =>
    res(ctx.json(appHomeConfigFixture())),
  ),

  saveAppHomeConfigDraftMock((req, res, ctx) => {
    const body = req.body as any;
    return res(
      ctx.json(
        appHomeConfigFixture({
          draft: body?.config,
          hasUnpublishedChanges: true,
        }),
      ),
    );
  }),

  // Publishing promotes the draft and levels it, so the response comes back clean.
  publishAppHomeConfigDraftMock((_req, res, ctx) =>
    res(ctx.json(cleanAppHomeConfigFixture())),
  ),

  resetAppHomeConfigDraftMock((_req, res, ctx) =>
    res(ctx.json(cleanAppHomeConfigFixture())),
  ),

  setAppHomeConfigPreviewMock((req, res, ctx) => {
    const body = req.body as any;
    return res(
      ctx.json(
        appHomeConfigFixture({
          preview: previewFixture({
            enabled: true,
            userIds: body?.userIds ?? [],
            asOf: body?.asOf ?? null,
            /*
             * Echoed, so the portal can be exercised against a server that honors the
             * field before one exists. Defaults the way the real one will when it
             * lands: a session that names no feed shows the signed-in one.
             */
            stack: body?.stack ?? 'signedIn',
          }),
        }),
      ),
    );
  }),

  endAppHomeConfigPreviewMock((_req, res, ctx) => res(ctx.status(204))),

  listAppHomeConfigAuditMock((req, res, ctx) =>
    res(
      ctx.json(
        makeListResults(auditEntriesFixture(), req.url.searchParams, {
          listName: 'content',
        }),
      ),
    ),
  ),

  getAppHomeConfigAuditSnapshotsMock((req, res, ctx) =>
    res(ctx.json(auditSnapshotsFixture({ id: String(req.params.entryId) }))),
  ),
];
